import {gatewayInstance} from "../axiosInstance";
import {SERVICE_ENDPOINT} from "../const";

export const searchAuditReport = async (data) => {
    try {
        const response = await gatewayInstance.post(
            `${SERVICE_ENDPOINT.REPORT}/audit-report/search`,
            data,
        );
        return response.data;
    } catch (e) {
        console.error();
    }
};
